import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BulkDeleteCollection,
  ManagementMergeConflictsResponse,
  ManagementReader,
  ManagementResult,
  ManagementStatistic,
  Reader,
} from '@thiememeulenhoff/types';
import { ManagementEndpointService } from './management.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class ManagementService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(ManagementEndpointService);

  fetchResultForArrangementByActor(actorId: string, arrangementCode: string) {
    const endpoint = this.#endpoints.resultFromArrangementByActor(
      actorId,
      arrangementCode,
    );
    return this.#http.get<ManagementResult>(endpoint);
  }

  fetchStatisticsByActor(actorId: string) {
    const endpoint = this.#endpoints.statisticsByActor(actorId);
    return this.#http.get<ManagementStatistic>(endpoint);
  }

  mergeActorResults(
    formerActorId: string,
    targetActorId: string,
    arrangementCode?: string,
  ) {
    return this.#http.post(
      this.#endpoints.mergeActorResults(
        formerActorId,
        targetActorId,
        arrangementCode,
      ),
      {},
    );
  }

  fetchMergeConflicts(
    formerActorId: string,
    targetActorId: string,
    arrangementCode?: string,
  ) {
    const endpoint = this.#endpoints.mergeConflicts(
      formerActorId,
      targetActorId,
      arrangementCode,
    );

    return this.#http.get<ManagementMergeConflictsResponse>(endpoint);
  }

  bulkDeleteResult(collection: BulkDeleteCollection) {
    const endpoint = this.#endpoints.bulkDeleteResult();

    return this.#http.delete(endpoint, {
      body: collection,
    });
  }

  fetchReaders() {
    const endpoint = this.#endpoints.managementReaders();

    return this.#http.get<Array<ManagementReader>>(endpoint);
  }
}
